<template>
  <div class="action-logs-tabs-page">
    <RouterTabs :tabs="tabs" :tab-with-children-routes="['version-history']" />
    <router-view />
  </div>
</template>

<script lang="ts" setup>
import RouterTabs from "@/components/RouterTabs";
import links from "@/router/links";

const tabs = [
  { path: "./action-logs", label: "Action logs", name: links.games.actionLogs },
  { path: "./version-history", label: "Version history", name: links.games.versionHistoryList },
];
</script>
